import React, { createContext, useEffect, useState, useContext } from "react";

import { SurveyRespondentDataContext } from "./survey-respondent-data";

import * as SurveyData from "../utils/survey/data";
import * as Answers from "../utils/survey/answers";
import * as API from "../utils/api";

import * as Storage from "../utils/storage";

import { SURVEY_STATUS } from "../constants/survey_status";

// Provee a los componentes las variables y funciones necesarias para la gestión de preguntas y respuestas
// de la encuesta actual.
// Por medio de la "surveyRoute" se solicita la encuesta correspondiente en la base de datos

export const SurveyContext = createContext();

const SurveyProvider = ({ children, data }) => {
  const { respondentId, respondentIdType, surveyId, setSurveyStatus } = useContext(
    SurveyRespondentDataContext
  );

  const { questionnaire, pages } = SurveyData.destructureData(data.surveyData);
  const [answers, setAnswers] = useState(Answers.loadAnswers(data.dbAnswers));

  const updateAnswersOnMarkedAnswer = (dimensionIndex, questionIndex, question, inputData) =>
    setAnswers({
      ...Answers.updateAnswersOnMarkedAnswer(
        answers,
        dimensionIndex,
        questionIndex,
        question,
        inputData
      ),
    });

  const updateAnswersOnDeletedAnswer = (dimensionIndex, questionIndex, question, formData) =>
    setAnswers({
      ...Answers.updateAnswersOnDeletedAnswer(
        answers,
        dimensionIndex,
        questionIndex,
        question,
        formData
      ),
    });

  const updateAnswersOnHiddenQuestion = (dimensionIndex, questionIndex) =>
    setAnswers({
      ...Answers.updateAnswersOnHiddenQuestion(answers, dimensionIndex, questionIndex),
    });

  const clearAnswersFromDimension = (dimensionIndex) =>
    setAnswers({
      ...Answers.clearAnswersFromDimension(answers, dimensionIndex),
    });

  const saveAnswers = async () =>
    API.saveAnswers(respondentId, respondentIdType, surveyId, answers);

  const finishSurvey = async () => {
    API.finishSurvey(respondentId, respondentIdType, surveyId);
    setSurveyStatus(SURVEY_STATUS.DONE);
  };

  // Actualización del local storage cuando las respuestas del usuario o la visibilidad de una pregunta cambia
  useEffect(() => {
    Storage.setItem(["survey", "answers"], answers);
    // console.log(Storage.getItem(["survey", "answers"]));
  }, [answers]);

  return (
    <SurveyContext.Provider
      value={{
        questionnaire,
        pages,
        answers,
        saveAnswers,
        finishSurvey,
        clearAnswersFromDimension,
        updateAnswersOnMarkedAnswer,
        updateAnswersOnDeletedAnswer,
        updateAnswersOnHiddenQuestion,
      }}
    >
      {children}
    </SurveyContext.Provider>
  );
};

export default SurveyProvider;
